import Vue from 'vue'
import Simplebar from 'simplebar-vue'

Vue.component('Simplebar', Simplebar)
